import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

/**
 * Track SPA page views on route change.
 * Drop this into AppContent so every navigation fires a page_view event.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Small delay to let react-helmet update document.title
    const timer = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 100);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);
}
